import { useState } from 'react';

interface UseTabManagerProps {
  initialTab?: number;
  onTabChange?: (tabIndex: number) => void;
}

export function useTabManager({ 
  initialTab = 0, 
  onTabChange 
}: UseTabManagerProps = {}) {
  const [activeTab, setActiveTab] = useState<number>(initialTab);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    if (onTabChange) {
      onTabChange(newValue);
    }
  };

  const switchToTab = (tabIndex: number) => {
    setActiveTab(tabIndex);
    if (onTabChange) {
      onTabChange(tabIndex);
    }
  };

  return {
    activeTab,
    handleTabChange,
    switchToTab
  };
}
